export default "__VITE_ASSET__77005ebf__"